module.exports = __webpack_public_path__ + "img/pc.de302e7e.png";